export default [{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8b1' },
  name: { value: 'August Month Promotion Template' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 1 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 1 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      },
      {
        children: {
          id: { value: 2 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7900.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      },
      {
        children: {
          id: { value: 3 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 3 },
          name: { value: '7600.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1533580200 },
  modified: { value: 1504606462 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8b2' },
  name: { value: 'Summer Free Oil Change' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 2 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '0fb25e974dec42c0b7c7d4ecb22ccc09' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1533580200 },
  modified: { value: 1532975400 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8b3' },
  name: { value: 'Car Service offer 30%' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 3 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '0fb25e974dec42c0b7c7d4ecb22ccc09' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1532975400 },
  modified: { value: 1533580200 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8b4' },
  name: { value: 'Save upto $3,500' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 4 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1533580200 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8b5' },
  name: { value: 'Christmas promotions' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 5 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1504606462 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8b6' },
  name: { value: 'Launching a new car' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 6 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1504606462 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8b7' },
  name: { value: 'Car exchange offer' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 7 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1504606462 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8b8' },
  name: { value: 'Most fuel efficient' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 8 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1504606462 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8b9' },
  name: { value: 'Toyota Tacoma Models in stock for sale' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 9 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1504606462 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8c0' },
  name: { value: 'Car Discounts in September 2018' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 10 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1504606462 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8c1' },
  name: { value: 'Special summer offers' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 11 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1504606462 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8c2' },
  name: { value: 'Start your next purchase online' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 12 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1504606462 }
},
{
  id: { value: '91ce01a43a6f4c0abe85d3030bf9e8c3' },
  name: { value: 'Limited Regional car offer' },
  thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
  contentBlocks: {
    value: [
      {
        children: {
          id: { value: 13 },
          thumbnailUrl: { value: 'https://dummyimage.com/55x44/b3b3b3/fff.png' },
          channel: { value: 2 },
          name: { value: '7800.jpg' },
          fileSize: { value: null },
          mimeType: { value: 'image/jpeg' },
          width: { value: null },
          height: { value: null },
          published: { value: null },
        }
      }
    ]
  },
  shareTo: {
    children: {
      affiliations: {
        value: [
          {
            children: {
              id: { value: '2ec78b0585f54c45bad94bd9d61b3e41' },
              silos: {
                value: [
                  { value: '0de79383472e11e8a3bf12aa047e7152' },
                  { value: '346e4f59a301481b8e095db4f1cf4dab' }
                ]
              }
            }
          }
        ]
      },
      silos: {
        value: [
          { value: '4b507fd151c7449da72e05fafc48bfb2' },
          { value: '5164c88d8c684c988fc3999badeec115' }
        ]
      }
    }
  },
  statusType: { value: 'Active' },
  tags: {
    value: [
      {
        children: {
          id: { value: '1' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2017' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '2' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2018' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '3' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '2019' },
          resources: { value: [] }
        }
      },
      {
        children: {
          id: { value: '4' },
          owner: { value: 'orn:entity:1234567890' },
          name: { value: '4Runner' },
          resources: { value: [] }
        }
      }
    ]
  },
  created: { value: 1492801055 },
  modified: { value: 1504606462 }
}]



// WEBPACK FOOTER //
// src/pages/content-block-page/data.js